export default __webpack_public_path__ + "static/service1-feac6ab5606d8acc728e5fcad29f920f.png";